import { Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { IUser } from "../interface/user";
import { GenericLayerService } from "./generic-layer.service";

@Injectable()
export class AssetAttributesService {
  currentUser: IUser;
  constructor(private authenticationService: AuthenticationService, private genericLayerService: GenericLayerService) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  getFieldAlias() {
    // gets FieldAliases_Evw
    return this.genericLayerService.getAllFeatures(this.currentUser.tableIds.fieldAliasId);
  }
  getTableAlias() {
    return this.genericLayerService.getAllFeatures(this.currentUser.tableIds.tableAliasId);
  }
  getELifeBaseLifeConfig(layerID) { //E=Expected
    return this.genericLayerService.getAllFeatures(layerID);
  }
  getELUnquieField(layerId, fieldName) {
    return this.genericLayerService.getUniqueValuesByField(layerId, fieldName);
  }
  getELSheetingType(layerId, fieldName, value) {
    return this.genericLayerService.getFilteredFeaturesByField(layerId, fieldName, value);
  }
  getTableValues(layerId, fieldName, value) {
    return this.genericLayerService.getFilteredFeaturesByField(layerId, fieldName, value);
  }
  getElifeTableValues(layerId) {
    return this.genericLayerService.getAllFeatures(layerId);
  }
  getDomainValues() { // why have this, with same name and signature, to simply pass through to genericLayerService?
    return this.genericLayerService.getDomainValues();
  }
  postExpectedLifeValues(UserId, Obj) {
    return this.genericLayerService.postExpectedLife(UserId, Obj);
  }
  // Added by Abhilash for JIRA ID:-27 JIRA ID:-29 on 08/18/2021
  getMaintenanceConfig() {
    //return MaintenanceConfiguration table. These record values are set on client Admin Task Attribute panel
    return this.genericLayerService.getAllFeatures(this.currentUser.tableIds.maintenanceConfigId);
  }
}
